import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format, subDays } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import SelectorChip from 'components/DesignSystem/SelectorChip';
import { DATE_FORMAT } from 'helper/products/synopticCharts';
import { selectDate, setDate } from 'redux/reducers/synopticChartsReducer';
import useGetAvailableDates from 'utils/hooks/synopticCharts/useGetAvailableDates';

const DAYS_WINDOW = 15;

export default function DateSection() {
  const dispatch = useDispatch();
  const { dates } = useGetAvailableDates();
  const selected: string | undefined = useSelector(selectDate);

  const availableStrings = new Set((dates ?? []).map((date) => format(date, DATE_FORMAT)));

  const today = new Date();
  const days = Array.from(
    { length: DAYS_WINDOW },
    (_, offset) => subDays(today, DAYS_WINDOW - 1 - offset),
  );

  return (
    <div className="sc-mobile-panel-dates">
      <p className="sc-mobile-panel-hint">
        Somente os últimos dias com dado gerado. Datas indisponíveis ficam desabilitadas.
      </p>
      <div className="sc-mobile-panel-date-grid">
        {days.map((day) => {
          const dayString = format(day, DATE_FORMAT);
          const available = availableStrings.has(dayString);
          const isSelected = selected === dayString;
          return (
            <SelectorChip
              key={dayString}
              shape="cell"
              selected={isSelected}
              disabled={!available}
              className="sc-mobile-panel-date-chip"
              onClick={() => dispatch(setDate(dayString))}
            >
              <span className="sc-mobile-panel-date-wd">
                {format(day, 'EEEEEE', { locale: ptBR })}
              </span>
              <span className="sc-mobile-panel-date-d">{format(day, 'dd')}</span>
              <span className="sc-mobile-panel-date-mm">
                {format(day, 'MMM', { locale: ptBR })}
              </span>
            </SelectorChip>
          );
        })}
      </div>
    </div>
  );
}
